import { getAuthClient } from "@/modules/authorisation/authClient";
import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export default async function redirectToHomeIfAuthorised() {
  const authorisationStore = useAuthorisationStore();
  const authClient = await getAuthClient();
  const token = await authClient.getAccessToken();
  if (token) {
    if (
      authorisationStore.redirectToAfterLoginUrl &&
      authorisationStore.redirectToAfterLoginUrl.includes("/auth/login")
    ) {
      authorisationStore.redirectToAfterLoginUrl = undefined;
    }

    return authorisationStore.getRedirectToAfterLoginUrl || { name: "dashboard" };
  }
  return undefined;
}
